import type { CSSProperties, ReactNode } from 'react';

/**
 * Card "aurora" do Indique e Ganhe (Claude Design · bow-perfil-indique.jsx):
 * base royal em gradiente profundo, borda ciano→azul→magenta de 1,5 px e um
 * brilho magenta que nasce no canto inferior direito. Usado no Perfil
 * (convite) e no topo da tela /indique (regra).
 *
 * Tokens do mock (não alterar sem o design): borda
 * `linear-gradient(135deg,#3BE0D0 0%,#2A6BD4 42%,#C04CAE 100%)`, fundo
 * `linear-gradient(150deg,#0A1F6E 0%,#07143C 58%,#12103A 100%)`, sombra
 * `0 10px 26px rgba(0,27,116,0.16)`, raio 26 externo / 24,5 interno.
 */
export const AURORA_BORDER = 'linear-gradient(135deg,#3BE0D0 0%,#2A6BD4 42%,#C04CAE 100%)';
export const AURORA_BG = 'linear-gradient(150deg,#0A1F6E 0%,#07143C 58%,#12103A 100%)';
/** Verde-menta dos destaques sobre o fundo escuro (eyebrow / "seu amigo ganha"). */
export const AURORA_ACCENT = '#4FE39B';

export function AuroraCard({
  children,
  padding = '22px 22px 24px',
  className = '',
  style
}: {
  children: ReactNode;
  padding?: string;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <div
      className={className}
      style={{
        borderRadius: 26,
        padding: 1.5,
        background: AURORA_BORDER,
        boxShadow: '0 10px 26px rgba(0,27,116,0.16)',
        ...style
      }}
    >
      <div
        className="relative overflow-hidden text-bow-cream"
        style={{ borderRadius: 24.5, background: AURORA_BG, padding }}
      >
        <span
          aria-hidden
          className="pointer-events-none absolute rounded-full"
          style={{
            right: -34,
            bottom: -66,
            width: 210,
            height: 190,
            background:
              'radial-gradient(circle at 50% 50%, #E27CE0 0%, #A24BD8 38%, rgba(92,44,168,0) 72%)',
            opacity: 0.85,
            filter: 'blur(14px)'
          }}
        />
        <span
          aria-hidden
          className="pointer-events-none absolute rounded-full"
          style={{
            right: 30,
            bottom: -18,
            width: 92,
            height: 92,
            background: 'radial-gradient(circle, #F3C4F2 0%, rgba(226,124,224,0) 70%)',
            opacity: 0.7,
            filter: 'blur(10px)'
          }}
        />
        <div className="relative">{children}</div>
      </div>
    </div>
  );
}
